import { Search, X } from 'lucide-react';

interface Props {
  value: string;
  onChange: (v: string) => void;
}

/** Navigation only — finds a topic by name. Searching *inside* messages is the
 *  message pane's job, scoped to the selected topic. */
export function TopicSearch({ value, onChange }: Props) {
  return (
    <div className="border-b border-(--color-border) bg-(--color-surface) p-[5px_8px]">
      <div className="relative">
        <Search
          size={12}
          className="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 opacity-40"
        />
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-label="Search topics"
          placeholder="Search topics…"
          className="w-full rounded-md border border-(--color-border) bg-(--color-bg) py-[5px] pl-7 pr-7 text-[0.923em] text-(--color-text) outline-none focus:border-(--color-green)"
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange('')}
            aria-label="Clear search"
            className="absolute right-1.5 top-1/2 -translate-y-1/2 cursor-pointer rounded p-0.5 text-(--color-text3) hover:bg-(--color-surface) hover:text-(--color-text)"
          >
            <X size={12} />
          </button>
        )}
      </div>
    </div>
  );
}
